import React from "react";
// import DummyAvatar from "../../../assets/images/Avatar.png";
import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
} from "@coreui/react";

const ClinicDD = ({ clinics, setClinic, clinicName = "Select Clinic" }) => {
  return (
    <div
      className="container-fluid w-100 my-4"
      style={{ cursor: "pointer", width: "100%", padding: "0px" }}
    >
      <CDropdown
        style={{ width: "100%" }}
        onClick={() => {
          document.getElementById("split").click();
        }}
      >
        <div
          className="d-flex justify-content-start w-100 dropdown-button-transparent"
          style={{ width: "100%" }}
        >
          <div className="text-white px-2">
            <span
              style={{
                width: "100%",
                color: "white",
                display: "block",
              }}
            >
              Current Clinic
            </span>
            <span
              style={{
                width: "100%",
                color: "white",
                display: "block",
              }}
            >
              {clinicName}
            </span>
          </div>
        </div>
        <CDropdownToggle
          id="split"
          split
          className="dropdown-button-transparent"
        />
        <CDropdownMenu
          style={{
            top: "100%",
            left: "15px",
            width: "92%",
            height: "10rem",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <CDropdownItem
            style={{ paddingTop: "10px", fontSize: "0.9rem" }}
            onClick={() => {
              setClinic(null);
            }}
          >
            Clear Clinic
          </CDropdownItem>
          <CDropdownDivider />
          {clinics?.map((clinic) => {
            return (
              <CDropdownItem
                style={{ paddingTop: "10px", fontSize: "0.9rem" }}
                key={clinic.value}
                onClick={() => {
                  setClinic(clinic.value);
                }}
              >
                {clinic.label}
              </CDropdownItem>
            );
          })}
        </CDropdownMenu>
      </CDropdown>
    </div>
  );
};

export default ClinicDD;
